<ng-container *ngIf="show">
   <div class="loading-container">
     <div class="loading-inner-container">
      <i class="fas fa-spinner  fa-spin fa-lg  icons"> </i>
     </div>
   </div>
</ng-container>
